import React, { PropTypes } from 'react';
import moment from 'moment';

import UserAvatar from 'components/UserAvatar';
import Link from 'components/Link';

import { CommentShape } from 'entities';

import './style.scss';

const SearchComment = (props) => {
  const { comment } = props;

  return (
    <div className="SearchComment">
      <div className="meta has-avatar">
        <UserAvatar letter={comment.author.userName[0]} imageUrl={comment.author.avatar.url} />
        <p><strong>{comment.author.userName}</strong> {__('members.search.comment.commentIn')} <strong><Link to={props.originUrl}>{props.originTitle}</Link></strong></p>
        <span className="time">{moment(comment.createdAt).fromNow()}</span>
      </div>
      <div className="text-wrapper">
        <p>{comment.text}</p>
      </div>
      <Link to={props.commentUrl}>{__('members.search.comment.moreLink')}</Link>
    </div>
  );
};

SearchComment.propTypes = {
  comment: CommentShape,
  originUrl: PropTypes.string,
  originTitle: PropTypes.string,
  commentUrl: PropTypes.string
};

export default SearchComment;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Search/SearchComment/index.js
 **/